var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20751_105527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9316 8.9668H24.5717C25.1991 8.9668 25.7077 9.47542 25.7077 10.1027V16.151C25.7077 18.4566 23.8386 20.3258 21.533 20.3258H21.5132C19.2076 20.3261 17.3382 18.4573 17.3379 16.1516V9.56057C17.3379 9.4826 17.3532 9.40539 17.3831 9.33335C17.4129 9.26131 17.4566 9.19585 17.5117 9.14071C17.5669 9.08558 17.6323 9.04184 17.7044 9.012C17.7764 8.98216 17.8536 8.9668 17.9316 8.9668Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4188 7.77124C23.9046 7.77124 25.1091 6.56675 25.1091 5.08093C25.1091 3.59512 23.9046 2.39062 22.4188 2.39062C20.933 2.39062 19.7285 3.59512 19.7285 5.08093C19.7285 6.56675 20.933 7.77124 22.4188 7.77124Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0491 7.77198C16.1953 7.77198 17.9351 6.03217 17.9351 3.88599C17.9351 1.73982 16.1953 0 14.0491 0C11.9029 0 10.1631 1.73982 10.1631 3.88599C10.1631 6.03217 11.9029 7.77198 14.0491 7.77198Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2304 8.9668H8.2696C7.64972 8.98216 7.15938 9.4966 7.17374 10.1165V17.0149C7.08718 20.7348 10.0301 23.8218 13.7499 23.9129C17.4697 23.8218 20.4127 20.7348 20.3262 17.0149V10.1165C20.3406 9.4966 19.8503 8.98216 19.2304 8.9668Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.3478 8.9668V18.6339C14.3464 18.8507 14.281 19.0623 14.1597 19.242C14.0385 19.4218 13.8668 19.5617 13.6663 19.6443C13.5358 19.6995 13.3955 19.7279 13.2538 19.7279H7.69974C7.62202 19.5306 7.55032 19.3333 7.49047 19.1301C7.2812 18.4441 7.17444 17.731 7.17365 17.0137V10.1147C7.15929 9.4958 7.64883 8.98216 8.26771 8.9669H14.3477L14.3478 8.9668Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7497 8.9668V19.2318C13.7497 19.3735 13.7213 19.5137 13.6661 19.6443C13.5835 19.8448 13.4436 20.0164 13.2638 20.1377C13.0841 20.2589 12.8725 20.3244 12.6557 20.3258H7.98071C7.87909 20.1285 7.78339 19.9312 7.69974 19.7279C7.61938 19.5325 7.54953 19.333 7.49047 19.1301C7.2812 18.4441 7.17444 17.731 7.17365 17.0137V10.1147C7.15929 9.4958 7.64883 8.98216 8.26771 8.9669H13.7498L13.7497 8.9668Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7498 8.9668V18.0361C13.7453 18.6384 13.2582 19.1256 12.6558 19.1301H7.49047C7.2812 18.4441 7.17444 17.731 7.17365 17.0137V10.1147C7.15929 9.4958 7.64883 8.98216 8.26771 8.9669H13.7498V8.9668Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.1521 8.9668V18.0361C13.1474 18.6384 12.6603 19.1256 12.058 19.1301H7.49047C7.2812 18.4441 7.17444 17.731 7.17365 17.0137V10.1147C7.15929 9.4958 7.64883 8.98216 8.26771 8.9669H13.1521V8.9668Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.3488 5.87726V7.76041C14.2472 7.76643 14.1515 7.77246 14.0498 7.77246C13.9482 7.77246 13.8525 7.76643 13.7509 7.76041C13.5491 7.74703 13.349 7.71503 13.1531 7.66481C12.5563 7.52347 12.0013 7.24287 11.5338 6.84595C11.0662 6.44902 10.6992 5.94705 10.4628 5.38109C10.3803 5.18828 10.3162 4.98809 10.2715 4.7832H13.2547C13.8579 4.78551 14.3465 5.27395 14.3488 5.87726Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7499 6.47482V7.76017C13.5481 7.7468 13.348 7.71479 13.1521 7.66457C12.5553 7.52322 12.0004 7.24261 11.5328 6.84569C11.0653 6.44877 10.6983 5.94681 10.4619 5.38086H12.6559C13.2592 5.38307 13.7476 5.8716 13.7499 6.47482Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7499 6.47482V7.76017C13.5481 7.7468 13.348 7.71479 13.1521 7.66457C12.5553 7.52322 12.0004 7.24261 11.5328 6.84569C11.0653 6.44877 10.6983 5.94681 10.4619 5.38086H12.6559C13.2592 5.38307 13.7476 5.8716 13.7499 6.47482Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.1522 6.47492V7.66467C12.5554 7.52333 12.0005 7.24271 11.5329 6.84577C11.0653 6.44883 10.6983 5.94684 10.4619 5.38086H12.0582C12.6615 5.38317 13.1499 5.8717 13.1522 6.47492Z",
    fill: "#0C1C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09587 5.38096H12.0565C12.6619 5.38096 13.1525 5.8716 13.1525 6.47683V17.4376C13.1525 18.0428 12.6619 18.5335 12.0566 18.5335H1.09587C0.490644 18.5335 0 18.0428 0 17.4376V6.47693C0 5.8715 0.490644 5.38086 1.09587 5.38086V5.38096Z",
    fill: "url(#paint0_linear_20751_105527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4608 9.55195H7.26967V15.5184H5.87376V9.55195H3.69287V8.39453H9.4608V9.55195Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20751_105527",
    x1: 2.28485,
    y1: 4.52462,
    x2: 10.8677,
    y2: 19.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20751_105527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7071,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.4f0b8eb5fdfd595faa0808b6fd552de7.svg";
export { ForwardRef as ReactComponent };